import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { IconProps } from '@models/icons';
import { pressActionEffect } from '@styles/mixin';
import { JSX } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    label: string;
    icon: (props: IconProps) => JSX.Element;
    onClick?: () =>void;
}

function SidebarButton({ label, icon: Icon, onClick }:Props) {
    const { i18n } = useTranslation();
    const { language } = i18n;
    return (
        <Container spacing={2}
            align='center'
            onClick={onClick}
            isJa={language === 'ja'} >
            <Icon size={24} color={colors.textSecondary}/>
            <BreakText color={colors.textSecondary} align='center'>
                {label}
            </BreakText>
        </Container>
    );
}

const Container = styled(Column)<{
    isJa?: boolean;
}>`
    background-color: var(--color-background-pure);
    border: 1px solid var(--color-border-default);
    padding: var(--spacing-4) var(--spacing-2);
    border-radius: var(--radius-4);
    min-height: ${({ isJa }) => (isJa ? '106px' : 'unset')};
    ${pressActionEffect}
`;

const BreakText = styled(Text)`
    word-break: break-word;
`;

export default SidebarButton;
